import PropTypes from 'prop-types';

function AboutSection({ t }) {
    return (
        <section className="about section-panel">
            <div className="content-width about-stage">
                <svg className="about-lines" viewBox="0 0 1200 450" preserveAspectRatio="none" aria-hidden="true">
                    <circle cx="122" cy="102" r="3" /><circle cx="122" cy="300" r="3" /><circle cx="1044" cy="184" r="3" /><circle cx="824" cy="326" r="3" />
                    <circle className="about-star star-a" cx="82" cy="58" r="1.5" /><circle className="about-star star-b" cx="246" cy="164" r="2" />
                    <circle className="about-star star-c" cx="328" cy="48" r="1" /><circle className="about-star star-d" cx="458" cy="118" r="2.5" />
                    <circle className="about-star star-e" cx="566" cy="356" r="1.5" /><circle className="about-star star-f" cx="698" cy="72" r="2" />
                    <circle className="about-star star-g" cx="776" cy="236" r="1" /><circle className="about-star star-h" cx="916" cy="44" r="1.5" />
                    <circle className="about-star star-i" cx="1102" cy="108" r="2" /><circle className="about-star star-j" cx="1138" cy="348" r="1" />
                </svg>
                <div className="feature-connector feature-connector--left"><span className="connector-line" aria-hidden="true" /><div className="feature-pill"><span className="feature-dot" />{t('limited')}</div></div>
                <div className="about-copy"><h2>{t('aboutTitle')}</h2><p>{t('aboutText')}</p></div>
                <div className="feature-connector feature-connector--right"><span className="connector-line" aria-hidden="true" /><div className="feature-pill"><span className="feature-dot" />{t('install')}</div></div>
            </div>
        </section>
    );
}

AboutSection.propTypes = {
    t: PropTypes.func.isRequired,
};

export default AboutSection;
